import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'sz-delta-chip',
  templateUrl: './sz-delta-chip.component.html',
  styleUrls: ['./sz-delta-chip.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class SzDeltaChipComponent {
  readonly value: InputSignal<number> = input.required<number>();
  readonly suffix: InputSignal<string> = input<string>('wk');
}
